import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as uuid from 'uuid';

@Injectable()
export class CorrelationIdInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    
    const xcor = req.headers.get('X-CORRELATION-ID');

    if(xcor === undefined || xcor === null){
        const id = uuid.v4();
        const modifiedReq = req.clone({
            setHeaders: {
              'X-CORRELATION-ID': id
            }
          });

          return next.handle(modifiedReq);
    }
    else{
        return next.handle(req);
    }
  }
}
